import { useEffect, useState } from "react";

const DEFAULT_MAX_ATTEMPTS = 5;
const BASE_DELAY_MS = 500; // первый ретерн
const MAX_DELAY_MS = 5000; // максимальная пауза

function wait(ms) {
  return new Promise((res) => setTimeout(res, ms));
}

// exponential backoff with jitter
function getDelay(attempt) {
  const exp = Math.min(BASE_DELAY_MS * 2 ** (attempt - 1), MAX_DELAY_MS);
  // add jitter: random between 75% and 100% of exp
  const jitter = exp * (0.75 + Math.random() * 0.25);
  return Math.round(jitter);
}

export default function HealthCheck() {
  const [status, setStatus] = useState("loading"); // loading | ok | failed
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function check() {
      const maxAttempts = Number(
        process.env.NEXT_PUBLIC_HEALTH_MAX_ATTEMPTS || DEFAULT_MAX_ATTEMPTS
      );
      for (let i = 1; i <= maxAttempts; i++) {
        if (cancelled) return;
        setAttempt(i);
        try {
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 10000); // 10s на один запрос
          const res = await fetch("/api/ping", {
            signal: controller.signal,
            cache: "no-store",
          });
          clearTimeout(timeout);
          if (res.ok) {
            const json = await res.json();
            if (!cancelled) {
              setStatus(json.status || "ok");
            }
            return;
          } else {
            // статус не 2xx, попробуем снова
          }
        } catch (e) {
          // ошибка сети / таймаут
        }
        if (i < maxAttempts) {
          const delay = getDelay(i);
          if (!cancelled) await wait(delay);
        }
      }
      if (!cancelled) setStatus("failed");
    }

    check();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div>
      <strong>Backend:</strong>{" "}
      {status === "loading" && (
        <>⏳ проверка... (попытка {attempt || 1})</>
      )}
      {status === "ok" && <>✅ ok</>}
      {status === "failed" && <>❌ недоступен</>}
    </div>
  );
}